import {createContext, useContext} from 'react';

export type NavigationContextType = {
  collapsed: boolean;
};

export const NavigationContext = createContext<NavigationContextType>({
  collapsed: false,
});

export function useNavigationContext() {
  return useContext<NavigationContextType>(NavigationContext);
}
